/* istanbul ignore file */
import makeStyles from '@material-ui/styles/makeStyles';
import { colors } from '../../theme/color-palette';
import { BOGLE_REGULAR } from '../../constants/constant';

const {
	WHITE,
	PURPLE_ACTIVE,
	GREY,
	LIGHT_GRAY_SHADE,
	ERROR_MD,
	TOGGLE_ACTIVE,
	BLACK,
	LIGHT_GRAY_HEX,
} = colors;

export default makeStyles(() => ({
	UpcButtonContainer: {
		display: 'flex',
		flexDirection: 'row-reverse',
		alignItems: 'center',
		justifyContent: 'flex-start',
		alignContent: 'flex-start',
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
		},
	},
	btnContainer: {
		display: 'flex',
		alignItems: 'right',
		justifyContent: 'right',
	},

	itemContainer: {
		position: 'relative',
		'@media (max-width: 1500px)': {
			width: '100% !important',
		},
	},

	itemDropDown: {
		height: '270px',
		width: '362px',
		background: WHITE,
		borderRadius: '8px',
		padding: '16px 16px 0px',
		zIndex: 10,
		boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
	},

	chipContainer: {
		height: '166px',
		width: '100%',
		borderRadius: 4,
		position: 'relative',
		'& .MuiOutlinedInput-root': {
			position: 'unset',
			'&.Mui-focused fieldset': {
				border: `1px solid ${PURPLE_ACTIVE}`,
			},
			'& fieldset': {
				border: `1px solid ${PURPLE_ACTIVE}`,
			},
			'&:hover fieldset': {
				borderColor: PURPLE_ACTIVE,
			},
		},
	},

	chipInput: {
		position: 'absolute',
		height: '48px',
		padding: '0px 0px 0px 12px',
		color: GREY,
		bottom: 0,
	},

	itemSelectBtn: {
		padding: '3px 15px !important',
		borderRadius: '4px',
		textTransform: 'none',
		border: `1px solid #c7c8cb`,
		color: '#6d6e71',
		'@media (max-width: 1500px)': {
			width: '100% !important',
			justifyContent: 'flex-start !important',
		},
	},

	selected: {
		background: TOGGLE_ACTIVE,
		borderColor: PURPLE_ACTIVE,
		borderRadius: '4px 0 0 4px',
		zIndex: 20,
		position: 'relative',
	},

	itemSelectBtnZIndex: {
		zIndex: 14,
		border: `2px solid ${PURPLE_ACTIVE}`,
		backgroundColor: TOGGLE_ACTIVE,
	},

	searchDropDown: {
		width: '360px',
		background: WHITE,
		borderRadius: '8px',
		padding: '16px 0px 0px',
		zIndex: 20,
		boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
	},
	searchContainer: {
		width: 328,
		height: 48,
		margin: '0px 16px',
		borderRadius: 4,
		'& .MuiOutlinedInput-root': {
			position: 'unset',
			'&.Mui-focused fieldset': {
				border: `1px solid ${PURPLE_ACTIVE}`,
			},
			'& fieldset': {
				border: `1px solid ${PURPLE_ACTIVE}`,
			},
			'&:hover fieldset': {
				borderColor: PURPLE_ACTIVE,
			},
		},
	},

	searchInput: {
		height: '48px',
		padding: '0px 0px 0px 12px',
		color: LIGHT_GRAY_HEX,
		fontSize: '14px',
		fontFamily: BOGLE_REGULAR,
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				borderColor: 'rgba(0, 0, 0, 0.23)', // default
			},
			'&.Mui-focused fieldset': {
				border: '2px solid red', // focus
			},
		},
	},

	searchSubText: {
		color: GREY,
		fontSize: 12,
		fontFamily: BOGLE_REGULAR,
		padding: '2px 16px 0px',
		marginBottom: 10,
		marginTop: 14,
	},

	chipsContainer: {
		position: 'absolute',
		padding: '0px 0px 0px 10px',
		boxSizing: 'border-box',
		width: 328,
		display: 'flex',
		flexWrap: 'wrap',
		maxHeight: 116,
		overflow: 'auto',
		zIndex: 1,
		marginTop: 8,
	},

	chips: {
		padding: '3px 6px',
		backgroundColor: LIGHT_GRAY_SHADE,
		marginRight: '4px',
		marginTop: '4px',
		borderRadius: 2,
		display: 'flex',
		width: '134px',
		fontSize: 14,
		justifyContent: 'space-between',
	},

	closeChip: {
		cursor: 'pointer',
	},

	itemValidation: {
		margin: '8px 0px',
		fontSize: '12px',
	},

	itemValidationSpacing: {
		margin: '15px 0px',
	},

	itemValidationError: {
		margin: '8px',
		fontSize: '12px',
		color: ERROR_MD,
	},

	cancelBtn: {
		border: '1px solid rgba(213, 214, 216, 1)',
		textTransform: 'none',
		height: '25px',
		padding: '5px 24px 5px 24px',
		color: 'rgba(60, 34, 138, 1)',
		borderRadius: '100px',
		fontSize: '16px',
		marginRight: '10px',
		fontWeight: 700,
	},
	applyBtn: {
		backgroundColor: 'rgba(60, 34, 138, 1)',
		textTransform: 'none',
		color: 'rgba(255, 255, 255, 1)',
		fontSize: '16px',
		borderRadius: '100px',
		fontWeight: 700,
		padding: '0px 24px 0px 24px',
		height: '35px',
		'&:hover': {
			background: '#3C228A',
			cursor: 'pointer',
		},
	},

	itemState: {
		marginRight: -5,
		color: BLACK,
	},

	removeAllErrors: {
		fontSize: 12,
		color: ERROR_MD,
		textDecoration: 'underline',
		cursor: 'pointer',
	},

	errormarkContainer: {
		display: 'flex',
	},

	errorChip: {
		background: '#FCE8E9',
	},

	loadingDots: {
		position: 'absolute',
		height: 42,
		left: 132,
		zIndex: '-1',
		top: '179px',
	},
	itemsPopover: {
		marginTop: 5,
	},
	popoverIndex: {
		zIndex: '14 !important',
	},
}));
